/**
 * Service tag constants for Sentry observability.
 * Import the appropriate tag in each app's entry/config file and pass it
 * to initBrowserSentry or setFrontendContext so Sentry events are attributed
 * to the correct service.
 *
 * Usage:
 *   fe-main (React / Webpack)  → SentryServiceTag.ReactFrontend
 *   fe-landing-page (Next.js)  → SentryServiceTag.NextFrontend
 *   Backend (Node / NestJS)    → SentryServiceTag.Backend  (for reference)
 */
export enum SentryServiceTag {
	ReactFrontend = 'react-frontend',
	NextFrontend  = 'next-frontend',
	BackendMain   = 'main-backend',
	BackendEvents = 'events-backend',
	BackendMediaCenter = 'mediacenter-backend',
	BackendStripe = 'stripe-backend',
	BackendInfra = 'infra-backend',
	BackendOpenAI = 'openai-backend',
	BackendMessages = 'messages-backend',
	BackendHomeFeedScheduler = 'home-feed-scheduler-backend',
	BackendPollsAndSurveys = 'polls-and-surveys-backend',

	// OpenEdx Backend comes below, also mattermost 
}
